import { setGetBonusCodeAction } from '../action';
import { getBonusCode } from '../api/getBonusCode';

export const setGetBonusCode = (params, callback) => {
    return async (dispatch, getState) => {
        try {
            const {data} = await getBonusCode(params);
            dispatch(setGetBonusCodeAction({
                data: data.data,
                currentPage: data?.pagination?.currentPage,
                currentRowsPerpage: data?.pagination?.currentRowsPerPage,
                total: data?.pagination?.total,
                totalPage: data?.pagination?.totalPage
            }))

            if (callback) {
                callback();
            }
        } catch(error) {
            if (error?.response?.status === 401) {
                localStorage.removeItem('token');
                window.location.replace(window.location.origin);
            }
        }
    }
}